/**
 * tempoEngine.js — Calcule un tempo (notation Excentrique-Pause bas-Concentrique-Pause haut,
 * en secondes, ex: "3-1-2-0") automatiquement selon le niveau du programme, l'objectif et la
 * technique (set_type) de l'exercice — reproduit les repères utilisés par les coachs pro :
 *  - Débutant : excentrique lent + pauses = contrôle technique maximal.
 *  - Avancé + force : concentrique explosif (rapide), excentrique contrôlé.
 *  - Avancé + prise de muscle : excentrique allongé = temps sous tension pour l'hypertrophie.
 *  - Technique "Tempo contrôlé" (set_type='tempo') : très lent quel que soit le niveau, c'est
 *    le principe même de la technique.
 *  - Techniques d'intensification à l'échec (drop set, rest-pause, myo-reps...) : tempo rapide,
 *    la vitesse d'exécution n'est plus la priorité une fois proche de l'échec.
 *  - Isométrique / exercices basés sur le temps : pas de tempo (durée déjà exprimée en secondes).
 * Reste purement une SUGGESTION modifiable — voir `tempo_auto` sur chaque exercice
 * (MyProgramBuilder.jsx) : recalculé en direct tant que le client n'a jamais tapé une valeur.
 */
const FAST_FAILURE_TYPES = new Set([
  'drop_set', 'rest_pause', 'cluster_set', 'myo_reps', 'twenty_ones', 'forced_reps', 'amrap', 'emom',
]);
const NO_TEMPO_TYPES = new Set(['isometric']);

const isForceGoal = (goal) => /force/i.test(goal || '');
const isHypertrophyGoal = (goal) => /muscle|hypertroph/i.test(goal || '');

export const computeAutoTempo = ({ level, goal, setType, isTimeBased }) => {
  if (isTimeBased || NO_TEMPO_TYPES.has(setType)) return '';
  if (setType === 'tempo') return '4-2-4-1';
  if (FAST_FAILURE_TYPES.has(setType)) return '1-0-1-0';

  if (level === 'Débutant') return '3-1-2-1';

  if (level === 'Avancé') {
    if (isForceGoal(goal)) return '3-1-1-0';
    if (isHypertrophyGoal(goal)) return '4-1-1-0';
    return '2-1-1-0';
  }

  // Intermédiaire (ou niveau non renseigné) : tempo équilibré par défaut.
  if (isForceGoal(goal)) return '3-0-1-0';
  if (isHypertrophyGoal(goal)) return '3-1-2-0';
  return '2-1-2-0';
};

export const TEMPO_HINT = 'Excentrique-Pause bas-Concentrique-Pause haut (secondes). Ex: 3-1-2-0 = 3s descente, 1s pause, 2s montée, 0s pause haut.';
